<template>

  <el-container class="search-page">
    <el-header style="height: 200px">
      <div class="search-page-title">您有什么需要帮助吗？</div>
      <el-form :model="searchObj" style="margin-top: 15px;">
        <el-input size="large" class="input" prefix-icon="el-icon-search"
                  maxlength="30"
                  placeholder="请输入内容" v-model="searchObj.searchText" @change="search">
        </el-input>
        <div class="inline-block v-middle">
          <div class="search-button" @click="search">搜索</div>
        </div>
      </el-form>
    </el-header>
    <el-main>
      <el-row >
        <!--   自助工具栏   -->
        <el-col :span="15" :style="{height: (itemSize + 1)/2 * 250}">
          <H1 class="tool-card-title">自助工具</H1>
          <el-col :span="10" style="margin-bottom: 25px;"
                  v-for="(o, index) in itemSize"
                  :key="o"
                  :offset="index%2 === 0 ? 0 : 1">
            <el-card :body-style="{ padding: '0px' }">
              <el-button type="primary" class="tool-button" @click="selectTool(index, $event)" plain>
                <i :class="tools[index].icon" style="font-size:50px; margin-bottom: 8px;"></i>
                <br>{{ tools[index].label }}
              </el-button>
            </el-card>
          </el-col>
        </el-col>
        <!--   热门回答栏   -->
        <el-col :span="9">
          <div style="padding-left: 20px;">
            <H1 class="tool-card-title">热门回答</H1>
            <el-table class="no-line-table"
                      style="margin-left: -10px; width: 100%"
                      :data="hotTicketList"
                      :show-header="false"
                      size="medium"
                      :row-style="{ height: '40px' }"
                      :cell-style="{padding: '0'}"
                      :header-cell-style="{ background: 'transparent', color: 'transparent' }"
                      @row-click="clickRow">
              <el-table-column prop="title">
                <template slot-scope="scope">
                  <div style="color: #1E1E1E; font-size: 16px ">{{ getTicketTitle(scope.row.title) }}</div>
                </template>
              </el-table-column>
            </el-table>
            <el-link type="primary"
                     style="margin-top: 10px; font-size: 15px; font-weight: bold; float:bottom"
                     @click="toHotTicket">更多热门回答 >>
            </el-link>
          </div>
        </el-col>
      </el-row>
      <div>
        <el-drawer title="问答详情" size="30%" :visible.sync="showDetail" direction="rtl">
          <div>
            <hot-ticket-detail :id="selectedId"></hot-ticket-detail>
          </div>
        </el-drawer>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import HotTicketDetail from "../ticket/hot-ticket-detail";

export default {
  name: "search",
  components: {HotTicketDetail},
  data() {
    return {
      searchObj: {
        searchText: '',
      },

      tools: [],
      tool: {
        icon: 'el-icon-question',
        label: '问题反馈',
        path: {
          route: '',
          currentTab: false,
        },
      },
      hotTicket: {
        total: 0,
        list: [],
      },
      hotTicketList: [],
      selectedId: null,
      showDetail: false,
      tableHeight: 200
    }
  },
  mounted() {
    this.getToolList();
    this.getHotTicketList();
  },
  computed: {
    itemSize() {
      return this.tools.length;
    },
  },
  methods: {

    // 页面跳转
    search() {
      let searchText = this.searchObj.searchText;
      if (searchText !== undefined && searchText.length > 0) {
        this.openTab(`/help/search?key=${searchText}`)
      }
    },

    openPage(path, currentTab) {
       if (currentTab) {
         this.$router.push(path);
       } else {
         this.openTab(path);
       }
    },

    openTab(path) {
      const {href} = this.$router.resolve({path: path});
      window.open(href, '_blank');
    },

    selectTool(index, event) {
      let target = event.target;
      if(target.nodeName === 'SPAN' || target.nodeName === 'I'){
        target = event.target.parentNode;
      }
      target.blur();
      let path = this.tools[index].path;
      this.openPage(path.route, path.currentTab);
    },

    getTicketTitle(title) {
      let maxLength = 20;
      console.log(title + '   length: ' + title.length);
      let result = title.substr(0, Math.min(title.length, maxLength));
      if (title.length > maxLength) {
        result = result + '...';
      }
      return result;
    },

    clickRow(row, column, event) {
      this.showDetail = true;
      this.selectedId = row.id;
    },

    toHotTicket() {
      this.openTab('/help/tickets/hot');
    },

    getToolList() {
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post("/ajax/doc/search/tools", {}).then(res => {
         this.hideCommonLoading();
         console.log(res);
         if (res.data.ret === 0) {
           this.tools = res.data.data;
         }
      }).catch(ex => {
        this.hideCommonLoading();
      })
    },
    getHotTicketList() {
      this.$axios.post('/ajax/doc/search/hot/list', {}).then(res => {
        if (res.data.ret === 0) {
          let content = res.data.data;
          this.hotTicket = content;
          this.hotTicketList = content.list;
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>


.search-page {
  width: 1200px;
  padding: 20px 0 30px 40px;
  margin: 0 auto;
}

.input {
  width: 78%;
  font-size: 15px;
  //margin-left: 3%;
}

.header {
  height: 100px;
}

.tool-button {
  background-color: white;
  font-size: 16px;
  height: 200px;
  width: 100%;
  border: 0;
  border-radius: 0;
  position: center
}

.tool-card-title {
  margin-bottom: 20px
}

.search-button {
  display: inline-block;
  margin-bottom: 3px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  background: #F16222;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  border-radius: 6px;
  vertical-align: middle;
  cursor: pointer;
  font-weight: bold;
}

.search-page-title {
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 28px;
  color: #212121;
  text-align: center;
  margin: 10px 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.no-line-table {
  /deep/ .el-table__row > td {
    border: none;
  }

  .el-table th, .el-table tr, .el-table td {
    border: 0;
    background-color: transparent;
  }

  /* 去掉上面的线 */
  /deep/ .el-table th.is-leaf {
    border: none;
  }

  /deep/ .el-table__row:nth-child(2n) {
    background: transparent;
  }
}

/* 去掉最下面的那一条线 */
/deep/ .el-table::before {
  height: 0px;
}


</style>


// WEBPACK FOOTER //
// src/components/help/toolbox.vue